"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.generateXlsx2Csv2Config = void 0;
const common_1 = require("@finley-technologies/common");
const tape_sanitizer_1 = require("@finley-technologies/tape-sanitizer");
const uinode_1 = require("./operations/sanitize/uinode");
const uinode_2 = require("./operations/xlsx2csv/uinode");
const generateXlsx2Csv2Config = ({ sanitizeNode, xlsx2csvNode, }) => {
    (0, common_1.finleyAssert)(uinode_2.operation_xlsx2Csv.isNode(xlsx2csvNode), '!Xlsx2CsvOperation');
    (0, common_1.finleyAssert)(uinode_1.operation_sanitize.isNode(sanitizeNode), '!SanitizeOperation');
    const { baseFields, delimiter, doNotSanitizeFieldNames, } = sanitizeNode.configuration;
    (0, common_1.debugLog)({
        sanitizeNode: sanitizeNode.metadata.tapeBuilderNodeId,
        baseFields,
    });
    (0, common_1.debugLog)({
        mode: xlsx2csvNode.configuration.mode,
        baseFields,
        delimiter,
        doNotSanitizeFieldNames,
    });
    switch (xlsx2csvNode.configuration.mode) {
        case 'convertRange': {
            const { sheetName, headerRange, dataEndRange, importRaw, formula, } = xlsx2csvNode.configuration;
            if (!headerRange) {
                return {
                    config: null,
                    errors: ['No header range in xlsx2csv'],
                };
            }
            const importFormat = importRaw ? 'raw' : 'formatted';
            const xlsx2csvConfig = {
                operation: 'xlsx2csv2',
                mode: 'convertRange',
                sheetName,
                isSheetNameRegex: true,
                headerRange,
                dataEndRange,
                fields: baseFields.map((baseField) => {
                    // sanitize
                    //   - reads from: baseField.columnToReadFrom ?? baseField.field
                    //   - writes to: getSanitizedFieldName(baseField.field, !doNotSanitizeFieldNames)
                    // when moving over the config to xlsx2csv2 we will make this explicit.
                    const columnToReadFrom = baseField.columnToReadFrom ?? baseField.field;
                    const fieldToWriteTo = (0, tape_sanitizer_1.getSanitizedFieldName)(baseField.field, !doNotSanitizeFieldNames);
                    return {
                        importFormat: formula ? 'formula' : importFormat,
                        ...baseField,
                        columnToReadFrom,
                        field: fieldToWriteTo,
                    };
                }),
            };
            return {
                config: xlsx2csvConfig,
                errors: [],
            };
        }
        case 'extractValues': {
            const errors = [];
            const { extract } = xlsx2csvNode.configuration;
            const fields = extract.map((field) => {
                const { sheetName, fieldName, cellAddress, importRaw } = field;
                const importFormat = importRaw
                    ? 'raw'
                    : 'formatted';
                // find matching baseField from the baseFields definitions
                // normalize using getSanitizedFieldName
                const matchingBaseFields = baseFields.filter((bf) => {
                    const columnToReadFrom = bf.columnToReadFrom ?? bf.field;
                    return columnToReadFrom === fieldName;
                });
                if (matchingBaseFields.length === 0) {
                    // if a field referenced in sanitize was not found
                    // in fields extracted from xlsx2csv, its really bad config
                    // but we allowed that in the past, and it worked fine for optional values.
                    // since optional values are optional.
                    errors.push(`[field: ${fieldName}] is referenced in sanitize but not found in xlsx2csv`);
                    return null;
                }
                if (matchingBaseFields.length > 1) {
                    errors.push(`multiple [${matchingBaseFields.length}] baseFields found for [fieldName:${fieldName}`);
                    return null;
                }
                const baseField = matchingBaseFields[0];
                const fieldToWriteTo = (0, tape_sanitizer_1.getSanitizedFieldName)(baseField.field, !doNotSanitizeFieldNames);
                return {
                    ...baseField,
                    sheetName,
                    isSheetNameRegex: true,
                    cell: cellAddress,
                    importFormat,
                    field: fieldToWriteTo,
                    columnToReadFrom: fieldName,
                };
            });
            const xlsx2csvConfig = {
                operation: 'xlsx2csv2',
                mode: 'extractValues',
                fields: fields.filter(common_1.typeguards.isNotNullOrUndefined),
            };
            return {
                config: xlsx2csvConfig,
                errors,
            };
        }
        default:
            return {
                config: null,
                errors: ['Invalid xlsx2csv mode'],
            };
    }
};
exports.generateXlsx2Csv2Config = generateXlsx2Csv2Config;
//# sourceMappingURL=generateXlsx2Csv2Config.js.map